module.exports = __webpack_public_path__ + "1264578da068b92d6cc9fa6542f00ddc.ttf";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-BoldItalic.ttf
// module id = 20
// module chunks = 0